<template>
  <div>
    <div class="reservation_lab">
      <a
        :href="reservationLink"
        target="_blank"
      ><span><strong>화상상담</strong> 예약하러 가기</span></a>
    </div>
    <!--
    <div class="right_btn">
      <button
        v-if="onButton"
        type="button"
        data-layer="reservation-lab-layer"
        @click="$emit('on-reservation-info')"
      >
        예약 안내사항
      </button>
    </div>
    -->
  </div>
</template>

<script>
export default {
  name: 'ReservationLink',
  props: {
    onButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      reservationLink: process.env.ACADEMY_RESERVATION_URL,
    };
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ReservationLink.vue